module.exports = __webpack_public_path__ + "static/free-stuff-for-freelancers-og-image-ab309e7d3d48122e27702c6cfac1031b.png";